"use client";

import { useEffect } from "react";
import { featureTamsense, isScriptario, tamsenseApiKey } from "@/lib/config";

let tamsenseInitialized = false;

export function TamsenseTracker() {
  useEffect(() => {
    if (tamsenseInitialized || !isScriptario || !featureTamsense || !tamsenseApiKey) {
      return;
    }

    tamsenseInitialized = true;

    import("@tamsensedev/dataclient")
      .then(({ DataClient }) => {
        new DataClient({ apiKey: tamsenseApiKey });
      })
      .catch((error) => {
        console.warn("[TAMsense] init error:", error);
      });
  }, []);

  return null;
}
